module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_courier":"Edit courier","edit_delivery_service":"Edit delivery service"},"id":{"edit_courier":"Sunting kurir","edit_delivery_service":"Sunting layanan pengiriman"}}')
  delete Component.options._Ctor
}
